export const REVIEWS_SLIDER_SETTINGS = {
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1250,
      settings: {
        arrows: false,
        slidesToShow: 2,
        variableWidth: true,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
        slidesToShow: 2,
        variableWidth: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 1,
        variableWidth: true,
      },
    },
    {
      breakpoint: 641,
      settings: {
        arrows: false,
        slidesToShow: 1,
        variableWidth: true,
        swipeToSlide: true,
      },
    },
  ],
};
